import { Strikethrough } from 'almanac-ui/icons/16'
import { KeyboardShortcutTag } from 'common/KeyboardShortcutTag/KeyboardShortcutTag'
import { useStrikethroughToggle } from 'common/Prose/Toolbar/hooks/useStrikethroughToggle'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { observer } from 'mobx-react-lite'
import { EditorView } from 'prosemirror-view'
import Styles from '../MoreOptionsDropdown.module.scss'

export const StrikethroughFormatButton = observer(function StrikethroughFormatButton({
  view,
  callback,
}: {
  view: EditorView
  callback?: () => void
}) {
  const { active, disabled, handleClick } = useStrikethroughToggle(view)

  return (
    <InlineFormatDropdownMenuItem
      label="Strikethrough"
      aria-label="Toggle strikethrough"
      data-testid="Toggle strikethrough"
      onClick={(event) => {
        handleClick(event)
        callback?.()
      }}
      active={active}
      isDisabled={disabled}
      icon={<Strikethrough />}
      rightContent={
        <KeyboardShortcutTag modifiers={['Mod', 'Shift']} keys="-" className={Styles.shortcutKey} size="sm" />
      }
    />
  )
})
